<template>
    <div class="all-height" style="width: 100%;position: relative">
        <el-row :gutter="20">
            <el-col :span="16">
                <template v-for="(item, index) in table.btns">
                    <el-button :key="index"
                               :icon="item.icon" @click="item.handler(sels)" :type="index === 0 ? 'primary' : ''"
                               :disabled="item.multi === true ? btn[2].disabled : (item.multi === false ? btn[1].disabled : btn[0].disabled)">{{item.text}}</el-button>
                </template>
            </el-col>
            <el-col :span="6">
                <el-input  v-if="queryForm.type === 'search'" v-model="queryForm.value"
                          :placeholder="queryForm.placeholder" @change="((val) => inputChange(val))"/>
            </el-col>
            <el-col :span="2">
                <el-button v-if="queryForm.type === 'search'" type="primary" @click="searchQuery">搜索</el-button>
            </el-col>
        </el-row>

        <div class="table-box">
            <el-table :data="table.data" height="calc(100% - 60px)" width="100%" v-loading="listLoading"
                  :header-cell-style="{background:'#4885CA',color: 'white'}"
                  @selection-change="selsChange" @select="events.select"
            >
                <el-table-column v-if="showConfig.check" type="selection" width="20" fixed="left"></el-table-column>
                <el-table-column v-if="showConfig.showNo" type="index" label="序号" width="50" fixed="left"></el-table-column>
                <slot v-for="(item, index) in table.cols" :name="item.code" :item="item">
                    <el-table-column v-if="showCols[index].istrue" :key="index"
                        :prop="item.code" :label="item.name" :width="item.width" :formatter="item.formatter"
                    >
                        <template slot-scope="scope">
                            <span v-html="item.formatter ? item.formatter(scope.row) : scope.row[item.code]"></span>
                        </template>
                    </el-table-column>
                </slot>
            </el-table>
        </div>
        <div class="table-page">
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="current"
                    :page-sizes="[100, 200, 300, 400]"
                    :page-size="100"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="400">
            </el-pagination>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'commonTable',
        props: {
            searchInput: {
                type: Object,
                default: function() {
                    return {};
                }
            },
            tableConfig: {
                type: Object,
                default: function() {
                    return {
                        cols: []
                    };
                }
            }
        },
        data() {
            return {
                btn: [{
                    disabled: false
                }, {
                    disabled: true
                }, {
                    disabled: true
                }],
                table: {},
                sels: [],
                queryForm: {},
                showCols: [],
                listLoading: false,
                queryConfig: {},
                showConfig: {},
                pageConfig: {
                    current: 1,
                    pageSize: [20, 50, 100, 500],
                    size: 20,
                    total: 0
                },
                events: {
                    select: function() {},
                    rowDblclick: function() {}
                },
                json_fields: {}
            }
        },
        methods: {
            inputChange(val) {
                this.queryForm.text = val;
            },
            queryTable() {
                this.listLoading = true;
                var params = this.getSearchForm();
                if (this.events && this.events.afterLoad) {
                    this.$store.dispatch(this.queryConfig.url, params).then((res) => {
                        this.listLoading = false;
                        this.events.afterLoad(res, this.table.data, this.pageConfig);
                    });
                } else {
                    this.$store.dispatch(this.queryConfig.url, params).then((res) => {
                        this.table.data = res.records;
                        this.pageConfig.current = res.current;
                        this.pageConfig.total = res.total;
                        this.listLoading = false;
                    });
                }
            },
            searchQuery() {
                this.queryTable();
            },
            getSearchForm() {
                let form = {};
                form[this.queryForm.code] = this.queryForm.value;
                form.current = this.pageConfig.current;
                form.size = this.pageConfig.size;
                return form;
            },
            selsChange(sels) {
                this.sels = sels;
                if (sels.length === 0) {
                    this.btn[1].disabled = true;
                    this.btn[2].disabled = true;
                } else if (sels.length === 1) {
                    this.btn[1].disabled = false;
                    this.btn[2].disabled = false;
                } else if (sels.length > 1) {
                    this.btn[1].disabled = true;
                    this.btn[2].disabled = false;
                }
            },
            handleSizeChange: function(val) {
                this.pageConfig.size = val;
                this.queryTable();
            },
            handleCurrentChange: function(val) {
                this.pageConfig.current = val;
                this.queryTable();
            },
        },
        created() {
            this.queryForm =  {
                code: this.searchInput.code,
                label: this.searchInput.label,
                type: this.searchInput.type ? this.searchInput.type : '',
                value: this.searchInput.value ? this.searchInput.value : '',
                text: this.searchInput.text ? this.searchInput.text : '',
                placeholder: this.searchInput.placeholder ? this.searchInput.placeholder : '',
                handler: this.searchInput.handler ? this.searchInput.handler : ''
            };
        },
        mounted() {
            //显示/隐藏配置
            this.showConfig = this.deepMerge({
                check: true,
                showNo: true,
                searchTag: true,
                rightBtn: true,
                moreSearch: false
            }, this.tableConfig.showConfig);
            //表格按钮
            this.table.btns = this.tableConfig.btns;
            //展示列
            var cols = [];
            if (this.tableConfig.cols && this.tableConfig.cols.length > 0) {
                for (var i = 0; i < this.tableConfig.cols.length; i++) {
                    cols.push(this.objMerge({
                        istrue: true
                    }, this.tableConfig.cols[i]));
                    this.showCols.push({
                        name: cols[i].name,
                        istrue: cols[i].istrue
                    });
                }
            }
            this.table.cols = cols;
            cols.forEach((cl) => {
                if (cl.istrue) {
                    if (cl.formatter) {
                        this.json_fields[cl.name] = {
                            field: cl.code,
                            callback: (value) => {
                                let row = {};
                                row[cl.code] = value;
                                return cl.formatter(row);
                            }
                        };
                    } else {
                        this.json_fields[cl.name] = cl.code;
                    }
                }
            });
            //分页
            if (this.tableConfig.pageConfig) {
                this.pageConfig = this.objMerge(this.pageConfig, this.tableConfig.pageConfig);
            }
            this.queryConfig = this.deepMerge({
                autoQuery: true
            }, this.tableConfig.queryConfig);
            //事件
            var es = this.tableConfig.events || {};
            this.events = this.deepMerge(this.events, es);
            //默认查询
            if (this.queryConfig.autoQuery) {
                this.queryTable();
            }
        }
    };
</script>
<style scoped>
    .table-box {
        position: relative;
        margin-top: 5px;
        background-color: white;
        height: calc(100% - 45px);
        width: calc(100% - 10px);
    }
    .table-header {
        width: 100%;
        height: 100%;
        color: white;
        text-align: center;
    }
    .table-page {
        width: 100%;
        text-align: center;
        position: absolute;
        bottom: 20px;
    }
    .table-box .el-table {
        height: calc(100% - 60px);
    }
</style>